import * as R from 'ramda';
import parseFollow from './parseFollow';

export default function parseFollows(items) {
  return R.map(parseFollow, items);
}
